'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import Loadable from 'UIComponents/decorators/Loadable';
import UILayer from 'UIComponents/layer/UILayer';
import UILoadingOverlay from 'UIComponents/loading/UILoadingOverlay';
import { URANUS_LAYER } from 'HubStyleTokens/sizes';
export default (loader => {
  return Loadable({
    loader,

    LoadingComponent({
      pastDelay
    }) {
      return pastDelay ? /*#__PURE__*/_jsx(UILayer, {
        children: /*#__PURE__*/_jsx("div", {
          style: {
            position: 'fixed',
            zIndex: URANUS_LAYER,
            top: 0,
            left: 0,
            right: 0,
            bottom: 0
          },
          children: /*#__PURE__*/_jsx(UILoadingOverlay, {})
        })
      }) : null;
    }

  });
});